<template>
  <trial-to-paid v-if='$context.is.trial2paid' />
  <div v-else-if='isFreeTrial'>
    <success :show-promotes='false'>
      <thanks :email='email' :title='trialTitle'>
        <subtitle :sub-title="trialSubtitle" />
        <zm-button
            v-if='isAutoAssigned'
            target='_blank'
            size='large'
            round
            type='primary'
            :href='ftLink'
            @click='goFreeTrialTracking'
            class='text-capitalize'>
          {{ $t('billing.trial.start_free_trial_btn', [buyTrialPlanName]) }}
        </zm-button>
        <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')" v-if='!isAutoAssigned' />
        <view-account type='round' v-if='isAutoAssigned && !isFromWebinar' />
        <zm-button
            v-if='isFromWebinar'
            target='_blank'
            size='large'
            round
            type='round'
            href='/webinar/list'
            referrerpolicy="same-origin"
            @click='backToProduct'
            class='text-capitalize'>
          {{ $t('billing.trial.webinar.back_to_webinar') }}
        </zm-button>
      </thanks>
    </success>
  </div>
  <CommonAddon v-else />
</template>
<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import Success from '@/views/succezz/facade.vue';
import common from '@/views/succezz/mixin/common';
import { mapGetters } from 'vuex';
import { pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';
import TrialToPaid from '@/views/succezz/components/trial-to-paid.vue';
export default {
  name: "Zoom Session",
  mixins: [common],
  components: { TrialToPaid, Success, Subtitle, ViewAccount, Thanks, UserManagementCta, CommonAddon },
  computed: {
    ...mapGetters(['successConfig']),
    isFreeTrial() {
      return this.$context.is.add2trial;
    },
    zeLink() {
      return this.successConfig.zeLink;
    },
    ftLink() {
      return `${this.zeLink}/e/get_started`;
    },
    buyTrialPlanName() {
      return this.$t('billing.planform.title.eventsaascore');
    },
    trialTitle() {
      if (!this.isAutoAssigned) {
        return this.$t('billing.trial.trial_manually_title')
      }
      return this.$t('billing.trial.trial_auto_assign_title', [this.buyTrialPlanName]);
    },
    isAutoAssigned() {
      return this.successConfig.assigned2currentUser;
    },
    trialSubtitle() {
      if (!this.isAutoAssigned) {
        return this.$t('billing.trial.trial_manually_assign');
      }
      return this.$t('billing.trial.saas.trial_success_desc');
    },
    isFromWebinar() {
      return pageConfig?.refer && pageConfig?.refer === planTypes.WEBINAR;
    }
  },
  methods: {
    goFreeTrialTracking() {
      this.$tracking.buyInteraction('purchase confirmation', 'set up zoom scheduler');
    },
    backToProduct() {
      this.$tracking.buyInteraction('purchase confirmation', `back to ${pageConfig?.refer}`);
    },
  },
}
</script>
